"use client";

import { MobileFooter as UiMobileFooter } from "@kkeut/ui/mobile-footer";
import { useLocale } from "@/components/LocaleProvider";
import { withLocaleHref } from "@/lib/locale-url";
import { branchConfig } from "@/config/branch";

export function MobileFooter() {
  const { locale } = useLocale();
  return (
    <UiMobileFooter
      branchId={branchConfig.branchId}
      locale={locale}
      withLocaleHref={withLocaleHref}
    />
  );
}

export default MobileFooter;
